import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { ChatLinkType } from 'components/customer/conversation_history/conversation_items_v2/chat/chat_self_service_metadata_item';
import ClickExternalLink from 'actions/customer_profile/click_external_link';
import connect from 'components/lib/connect';
import { getNormalizedUrl } from 'components/lib/linkify_it';
import { ProfileCardType } from 'models/configuration/profile_card_def';

export function ExternalLink({ className, url, text, onClick }) {
  if (!url) {
    return <div className={className}>{text || '-'}</div>;
  }

  return (
    <a
      className={classnames('externalLink', className)}
      href={getNormalizedUrl(url)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
    >
      <div className="externalLink-text">{text || '-'} </div>
    </a>
  );
}

ExternalLink.propTypes = {
  attrs: PropTypes.object,
  attrName: PropTypes.string,
  className: PropTypes.string,
  url: PropTypes.string,
  subType: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.oneOf([
    ProfileCardType.BASIC_PROFILE,
    ProfileCardType.CUSTOM_ATTRS,
    ProfileCardType.TRANSACTIONS,
    ChatLinkType,
    'ACTIVITY',
  ]),
  onClick: PropTypes.func.isRequired,
};

function mapExecuteToProps(executeAction, { type, subType, attrName }) {
  return {
    onClick: () => executeAction(ClickExternalLink, { type, subType, attrName }),
  };
}

export default connect(null, mapExecuteToProps)(ExternalLink);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/external_link.jsx